import axios, { isAxiosError } from 'axios';
import { createRef } from 'react';
import querystring from 'querystring';
import { isKahveDiyariDomain } from '../helpers/domainUtils';

export const tokenRef = createRef();

interface Parameters {
  url: string;
  data?: any;
  responseType?: any;
  onUploadProgress?: any;
  headers?: any;
  baseURL?: string; //enum
  withoutapplicaitonid?: boolean;
  reportAccessToken?: string; // Campaign Analytics için özel token
  skipUrlOrganizationId?: boolean; // URL'den organization ID çıkarma işlemini atla
}

const sendRequest = {
  post: (params: Parameters) => handleRequest(params, 'post'),
  put: (params: Parameters) => handleRequest(params, 'put'),
  get: (params: Parameters) => handleRequest(params, 'get'),
  delete: (params: Parameters) => handleRequest(params, 'delete'),
};

function extractOrganizationIdFromUrl(url: string): string | null {
  const parts = url.split('/');
  const organizationId = parts[2];
  return organizationId;
}

// Ortama göre default application ID'yi getir
function getDefaultApplicationId(): string {
  return isKahveDiyariDomain() ? 'pIsvirxheLBhVT8qsQTu5A==' : 'gh6GWKAVNN1eF1_-atbuwA==';
}

export default sendRequest;

function handleRequest(params: Parameters, method: any): Promise<any> {
  console.log('---> API Request: ', params.url, method);
  const BASE_URL = 'https://api-management.kaizenloyalty.com';
  return new Promise((resolve, reject) => {
    if (!params.url) {
      reject({ message: 'URL is required for http request' });
      return;
    }

    if (params.data && ['get', 'delete'].includes(method)) {
      params.url += '?' + querystring.stringify(params.data);
    }

    const currentPath = window.location.pathname;
    const isLoyaltyPage = currentPath.includes('/loyalty');
    const organizationId = !isLoyaltyPage ? extractOrganizationIdFromUrl(currentPath) : null;

    const request = axios.create({
      baseURL: BASE_URL + (params.baseURL || '/api/v1/application'),
    });

    const token = localStorage.getItem('token');
    const defaultHeaders: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      'x-subdomain': 'panel',
      'X-Organization-Application-Id': getDefaultApplicationId(),
    };

    // Report Access Token öncelikli olarak kullan
    if (params.reportAccessToken) {
      defaultHeaders['Authorization'] = 'Bearer ' + params.reportAccessToken;
    } else if (token) {
      defaultHeaders['Authorization'] = 'Bearer ' + token;
    } else {
      defaultHeaders['Authorization'] = 'Basic S0xQX0Jhc2ljQXV0aFVzZXI6S0xQX1Bhc3MxMjMh';
    }

    if (organizationId && organizationId.length > 10 && !isLoyaltyPage && !params.skipUrlOrganizationId) {
      defaultHeaders['X-Organization-Application-Id'] = organizationId;
    }

    if (params.url.includes('/activate') || params.url.includes('/changepasswordbyhash')) {
      delete defaultHeaders['X-Organization-Application-Id'];
    }

    if (params.withoutapplicaitonid) {
      delete defaultHeaders['X-Organization-Application-Id'];
    }
    request
      .request({
        method,
        responseType: params.responseType,
        url: params.url,
        data: params.data,
        onUploadProgress: params.onUploadProgress,
        headers: {
          ...defaultHeaders,
          ...params.headers,
        },
      })
      .then((res: any) => {
        resolve(res?.data?.data || res?.data);
      })
      .catch((err) => {
        if (isAxiosError(err)) {
          console.log('----> API Error: ', err?.response?.data || err.message);
        }
        reject(err);
      });
  });
}
